
import { KEY_LAYER_CHAIN, SYM_LAYER_INDENTIFY } from "../../enum/Symbol";
import PropArray from "../../type/propArray";
import useMap from "../../utils/useMap";
import useStoreMonitor from "../../warehouse/useStoreMonitor";
import useWarehouse from "../../warehouse/useWarehouse";
import { isLayer } from "./validator/useLayerIdentity";
import useStoreChain from "./store/useStoreChain";

const { provideDataWhenEmpty, removeData, setData, getData } = useWarehouse();

setData(KEY_LAYER_CHAIN, useMap())

const chainPool = getData(KEY_LAYER_CHAIN);

useStoreMonitor('KEY_LAYER_CHAIN', chainPool)

const useTrash = (() => {
    const storeChainId = new Set();

    const doClear = () => {
        chainPool.forEach(chainController => {
            const { isEmpty, discardChain } = chainController;
            if (isEmpty()) {
                discardChain();
            }
        })
        setTimeout(doClear, 10000);
    }

    setTimeout(doClear, 10000)

    return (chainId) => {
        storeChainId.add(chainId);
    }
})()


const generateChainID = (() => {
    let count = 0;
    return () => `chain[${++count}]`
})();

/**@returns {UserLayerChainController.LayerChainController} */
const useLayerChain = (chainId = generateChainID()) => {
    if (!chainPool.has(chainId)) {
        chainPool.set(chainId, useStoreChain(chainId));
    }
    return chainPool.get(chainId);
};

export default useLayerChain;
